import * as React from 'react'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import { useDisconnectHandler } from '../hooks/useDisconnectHandler'

type Props = {
  id: number
  name: string
  accountId: string
  synced: boolean
}

export function CampaignTrackingActive(props: Props) {
  const { id, accountId, name } = props

  const { handleDisconnect, loading } = useDisconnectHandler({
    callProviderId: id,
    name,
  })

  return (
    <Stack
      gap={2}
      sx={{
        width: '100%',
      }}
    >
      <Stack textAlign="center">
        <Typography variant="body1">Account ID</Typography>
        <Typography variant="h5">{accountId}</Typography>
      </Stack>
      <Button
        onClick={handleDisconnect}
        type="submit"
        variant="contained"
        size="large"
        disabled={loading}
        sx={{
          textTransform: 'none',
        }}
      >
        Disable sync
      </Button>
    </Stack>
  )
}
